import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconPlusLarge = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M12 4.008c.203 0 .375.07.516.21.156.141.234.321.234.54v6.492h6.492c.219 0 .399.078.54.234.14.141.21.313.21.516s-.07.383-.21.54a.73.73 0 0 1-.54.21H12.75v6.492a.693.693 0 0 1-.234.54.701.701 0 0 1-.516.21.782.782 0 0 1-.54-.21.73.73 0 0 1-.21-.54V12.75H4.758a.73.73 0 0 1-.54-.21.782.782 0 0 1-.21-.54c0-.203.07-.375.21-.516a.693.693 0 0 1 .54-.234h6.492V4.758a.73.73 0 0 1 .21-.54.782.782 0 0 1 .54-.21z" }),
});

export { IconPlusLarge };
